export default __webpack_public_path__ + "static/media/live-bg.de35aad0.png";